import { FormattedMessage } from '@99designs/common/i18n';
import { Currency, toUnit } from 'common/utils/currency';
import { FormattedCurrency } from 'projects/components/BudgetSlider';
import React from 'react';

export const FormattedBudget: React.FunctionComponent<{ budget: number; currency: string }> = ({
    budget,
    currency,
}) => {
    return (
        <FormattedMessage
            message={__('budget of {budget}')}
            values={{
                budget: (
                    <FormattedCurrency
                        value={toUnit(budget, currency as Currency)}
                        currency={currency as Currency}
                    />
                ),
            }}
        />
    );
};
